<div class="card relative">
    <!-- ====== DESKTOP/TABLET (≥ md) ====== -->
    @if (responsiveMode === 'breakpoint' ? isMdUp : null) {
        <div class="block" [class.hidden]="responsiveMode === 'css'" [class.md:block]="responsiveMode === 'css'">
            <!-- Custom Sort evita que se haga el sort automático de PrimeNG -->
            <p-table #dt [value]="data" dataKey="id" [loading]="loading" [globalFilterFields]="globalFilterCol()" [lazy]="true" (onLazyLoad)="loadData($event)">
                <ng-template pTemplate="caption">
                    <div class="mb-4">
                        <div class="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
                            <!-- BTN LIMPIAR FILTROS -->
                            <p-button label="{{ getTranslation('clear') }}" [outlined]="true" icon="pi pi-filter-slash" (click)="clearFilters(dt)" />
                            <!-- BUSCADOR -->
                            <p-iconfield iconPosition="left" class="ml-auto">
                                <p-inputicon><i class="pi pi-search"></i> </p-inputicon>
                                <input pInputText type="text" [(ngModel)]="searchValue" (input)="onGlobalFilter(dt, $event)" placeholder="Buscar..." />
                            </p-iconfield>
                            <!-- Slot opcional que vos uses -->
                            <ng-content select="[mostrarFiltros]"></ng-content>
                            <!-- Botón de filtros avanzados (abre el panel único) -->
                            @if (showFilterToggle) {
                                <button pButton type="button" icon="pi pi-sliders-h" [outlined]="true" class="adv-toggle-btn" (click)="toggleFiltrosAvanzados(); $event.stopPropagation()"></button>
                            }
                        </div>
                    </div>
                </ng-template>
                <!-- COLUMNAS -->
                <ng-template pTemplate="header">
                    <tr class="text-center align-middle">
                        @for (col of column; track col.field ?? $index) {
                            <th [style.width]="col.minWidth || 'auto'" [pSortableColumn]="getField(col.field)">
                                <div class="flex items-center gap-2" [style.width]="col.minWidth || 'auto'">
                                    {{ col.header }}
                                    @if (col.field) {
                                        <p-sortIcon [field]="getField(col.field)" />
                                    }
                                    @if (col.filterType !== 'select') {
                                        <p-columnFilter [field]="getField(col.field)" [type]="col.filterType || 'text'" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" placeholder="Filtrar..." appendTo="body" />
                                    } @else {
                                        <p-columnFilter [field]="getField(col.field)" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" matchMode="in">
                                            <ng-template #filter let-value let-filter="filterCallback">
                                                <p-multiSelect [options]="col.options" placeholder="Seleccione..." class="w-full md:w-60" display="chip" [ngModel]="value" (onChange)="filter($event.value)" appendTo="body" />
                                            </ng-template>
                                        </p-columnFilter>
                                    }
                                </div>
                            </th>
                        }
                        @if (otrasAcciones){
                            <th>{{ accionesHeader }}</th>
                        }
                    </tr>
                </ng-template>
                <!-- CUERPO -->
                <ng-template pTemplate="body" let-row>
                    <tr class="cursor-pointer hover:bg-surface-50 dark:hover:bg-surface-800/60" (click)="onDesktopRowTap(row, $event)">
                        @for (col of column; track col.field ?? $index) {
                            <td>
                                @if (customCell) {
                                    <ng-container *ngTemplateOutlet="customCell; context: { $implicit: row, column: col }"></ng-container>
                                } @else {
                                    @if (col.field === 'activo' || col.field === 'estado' || col.field === 'autorizacion' || col.field === 'autorizado' || col.field === 'seguimiento' || col.field === 'estadoLabel' || col.field === 'revision' || col.field === 'revision_gerencial' || col.field === 'riesgo') {
                                        <p-tag [value]="row[col.field]" [severity]="stateTag(row[col.field])" />
                                    } @else {
                                        {{ row[col.field] }}
                                    }
                                }
                            </td>
                        }
                        <td (click)="$event.stopPropagation()">
                            @if (accionesTemplate) {
                                <ng-container *ngTemplateOutlet="accionesTemplate; context: { $implicit: row }"></ng-container>
                            }
                        </td>
                    </tr>
                </ng-template>
                <!-- MENSAJE -->
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="column.length + 1" class="text-center">No se encontraron resultados.</td>
                    </tr>
                </ng-template>
            </p-table>
            <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows" [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]" />
            @if (totalVisible !== null) {
                <div class="p-text-right p-mt-2 text-xl">
                    <small>Mostrando {{ totalVisible }} resultado{{ totalVisible === 1 ? '' : 's' }} de {{ totalRecords ?? data.length }}</small>
                </div>
            }
        </div>
    }

    <!-- ====== MÓVIL (< md) ====== -->
    @if (enableMobileList && (responsiveMode === 'breakpoint' ? !isMdUp : null)) {
        <div class="block" [class.md:hidden]="responsiveMode === 'css'">
            <h3 class="text-3xl text-[#D4A520] dark:text-[#D4A520] tracking-tight mb-6 mt-4 pb-2">Histórico</h3>
            <!-- barra de acciones/filters -->
            <div class="mb-3 mobile-toolbar overflow-hidden">
                <div class="flex items-center gap-2">
                    <p-button
                        class="shrink-0"
                        label="{{ getTranslation('clear') }}"
                        [outlined]="true"
                        icon="pi pi-filter-slash"
                        (click)="limpiarFiltrosAvanzados.emit(); limpiarFiltrosTabla.emit(); searchValue = ''; mobileFirst = 0; rebuildMobileView()"
                    >
                    </p-button>
                    <p-iconfield iconPosition="left" class="flex-1 min-w-0">
                        <p-inputicon><i class="pi pi-search"></i></p-inputicon>
                        <input pInputText class="w-full" type="search" [(ngModel)]="searchValue" (ngModelChange)="onMobileGlobalFilter($event)" placeholder="Buscar..." />
                    </p-iconfield>
                    @if (showFilterToggle) {
                        <button pButton type="button" class="shrink-0 adv-toggle-btn" icon="pi pi-sliders-h" [outlined]="true" (click)="toggleFiltrosAvanzados(); $event.stopPropagation()"></button>
                    }
                </div>
            </div>
            <!-- lista agrupada (sólo página actual) -->
            <div class="group-list">
                @for (g of mobileGroupsView; track g.label) {
                    <div class="group-header">{{ g.label }}</div>
                    @for (row of g.items; track row.id ?? row.id_visible ?? $index) {
                        <article class="mrow" [ngClass]="getAccentClass(row)" (click)="onMobileRowTap(row, $event)" role="button" tabindex="0">
                            <div class="mrow__content">
                                <div class="mrow__title">{{ row[mobileTitleKey] }}</div>
                                <div class="mrow__lines">
                                    @for (f of mobileFields; track f.field ?? $index) {
                                        <div class="mrow__line">
                                            @if (f.label) {
                                                <span class="k">{{ f.label }}:</span>
                                            }
                                            @switch (f.type || 'text') {
                                                @case ('tag') {
                                                    <p-tag [value]="row[f.field]" [severity]="stateTag(row[f.field])"></p-tag>
                                                }
                                                @default {
                                                    <span>{{ row[f.field] }}</span>
                                                }
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                            <div class="mrow__right" (click)="onMobileActionClick(row, $event)">
                                @if (!mobileReuseActions) {
                                    <span class="cta">{{ mobileCtaLabel }}</span>
                                    @if (mobileCtaLabel) {
                                        <i class="pi pi-chevron-right opacity-70"></i>
                                    }
                                } @else {
                                    @if (mobileActionsTemplate) {
                                        <ng-container *ngTemplateOutlet="mobileActionsTemplate; context: { $implicit: row }"></ng-container>
                                    } @else {
                                        @if (accionesTemplate) {
                                            <ng-container *ngTemplateOutlet="accionesTemplate; context: { $implicit: row }"></ng-container>
                                        }
                                    }
                                }
                            </div>
                        </article>
                    }
                }
            </div>
            <!-- paginador móvil -->
            @if (mobileTotal > 0) {
                <div class="flex items-center justify-between mt-3">
                    <small class="opacity-70"> Mostrando {{ mobileFirst + 1 }}–{{ mobileLast }} de {{ mobileTotal }} </small>
                    <div class="flex gap-2">
                        <button pButton type="button" icon="pi pi-chevron-left" [outlined]="true" (click)="mobilePrevPage()" [disabled]="!mobileHasPrev"></button>
                        <button pButton type="button" icon="pi pi-chevron-right" [outlined]="true" (click)="mobileNextPage()" [disabled]="!mobileHasNext"></button>
                    </div>
                </div>
            }
            @if (mobileTotal === 0) {
                <p class="text-center opacity-70 py-8">Sin resultados.</p>
            }
        </div>
    }

    <!-- ========= PANEL ÚNICO DE FILTROS (sirve para móvil y desktop) ========= -->
    @if (panelOpen) {
        <div
            class="advanced-panel absolute right-0 md:right-0 top-14 md:top-10 z-50 w-[calc(100%-1rem)] md:w-[32rem] p-3 rounded-lg shadow border fade-expand bg-white text-black border-gray-300 dark:bg-[#1f1f1f] dark:text-[#e0e0e0] dark:border-[#444]"
            (click)="$event.stopPropagation()"
        >
            <ng-content select="[advancedFilters]"></ng-content>
        </div>
    }
</div>
